import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
// import _ from 'lodash'

import Select from '../../atoms/Select'

import './style.scss'

// const areEqual = (prevProps, nextProps) => {
//   // console.log(`Angelo Log ~ file: FilterSelect.jsx ~ line 9 ~ areEqual ~ prevProps, nextProps`, prevProps, nextProps)
//   const valueIsEqual = _.isEqual(prevProps.value, nextProps.value)
//   const optionsIsEqual = _.isEqual(prevProps.options, nextProps.options)

//   if (!valueIsEqual) {
//     console.log(`Angelo Log ~ file: FilterSelect.jsx ~ line 13 ~ valueIsEqual ~ shouldUpdate`, !valueIsEqual)
//   }

//   if (!optionsIsEqual) {
//     console.log(`Angelo Log ~ file: FilterSelect.jsx ~ line 13 ~ optionsIsEqual ~ shouldUpdate`, !optionsIsEqual)
//   }

//   return valueIsEqual || optionsIsEqual
// }

const FilterSelect = ({ id, type, tooltip, label, options, value, placeholder, selectedText, onChange, layout }) => {
  return (
    <React.Fragment>
      {label && (
        <label
          id={`fil-fund-filter__label-${label}`}
          className={classnames('fund-filter__label-select', {
            withTooltip: tooltip
          })}
        >
          {label}
        </label>
      )}
      {tooltip && <React.Fragment>{tooltip}</React.Fragment>}
      <Select
        id={id}
        type={type}
        placeholder={placeholder}
        selectedText={selectedText}
        // label={label}
        options={JSON.stringify(options)}
        value={value}
        // tooltip={tooltip}
        layout={layout}
        onChange={onChange}
      />
    </React.Fragment>
  )
}

FilterSelect.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  type: PropTypes.string,
  tooltip: PropTypes.any,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  selectedText: PropTypes.string,
  onChange: PropTypes.func,
  layout: PropTypes.string
}

FilterSelect.defaultProps = {
  type: 'multiple',
  layout: '1-col',
  tooltip: null,
  label: '',
  placeholder: '',
  selectedText: '',
  onChange: () => {}
}

export default React.memo(FilterSelect)
